import http from "../http"
import { Fixture, FixtureUpdateDTO } from "../../models/fixture"

class AdminFixtureService {
  private readonly baseUrl = "/admin"

  async updateFixture(id: string, dto: FixtureUpdateDTO) {
    const { data } = await http.put<Fixture>(`${this.baseUrl}/fixture/${id}`, dto)
    return data
  }

  async grabFixtureStats(leagueId: string, fixtureId: string) {
    const { data } = await http.post<{ message: string }>(
        `${this.baseUrl}/league/${leagueId}/fixture/${fixtureId}/stats`
    )
    return data
  }
}

export default new AdminFixtureService()
